// extracted by mini-css-extract-plugin
export default {"loader":"loading-circle_loader__e385E","spin":"loading-circle_spin__SDV63"};